import { apiClient } from './apiClient';

export const userService = {
  /**
   * Get current user profile
   */
  async getCurrentUser() {
    return apiClient.get('/api/users/me');
  },

  /**
   * Update current user profile
   * @param {Object} data - User data to update
   * @param {string} data.email - User email
   * @param {string} data.firstName - First name
   * @param {string} data.lastName - Last name
   * @param {string} data.phone - Phone number
   * @param {string} data.jobTitle - Job title
   * @param {string} data.bio - Bio/description
   * @param {string} data.timezone - Timezone
   */
  async updateProfile(data) {
    return apiClient.put('/api/users/me', data);
  },

  /**
   * Change user password
   * @param {Object} data - Password data
   * @param {string} data.currentPassword - Current password
   * @param {string} data.newPassword - New password
   */
  async changePassword(data) {
    return apiClient.put('/api/users/me/password', data);
  },

  /**
   * Get all users in company (admin only)
   */
  async getCompanyUsers() {
    return apiClient.get('/api/users');
  },

  /**
   * Get user by ID (admin only)
   * @param {number} id - User ID
   */
  async getUserById(id) {
    return apiClient.get(`/api/users/${id}`);
  },

  /**
   * Delete user (admin only)
   * @param {number} id - User ID
   */
  async deleteUser(id) {
    return apiClient.delete(`/api/users/${id}`);
  },
};
